
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Control } from "react-hook-form";
import { CharacterFormData } from "../validation/characterSchema";
import { CharacterFieldSelect } from "../components/CharacterFieldSelect";
import { useCharacterAgeGroups } from "@/hooks/useCharacterAgeGroups";
import { useCharacterColorThemes } from "@/hooks/useCharacterColorThemes";

interface CharacterDetailsSectionProps {
  control: Control<CharacterFormData>;
}

export const CharacterDetailsSection = ({ control }: CharacterDetailsSectionProps) => {
  const { ageGroups, isLoading: ageGroupsLoading } = useCharacterAgeGroups();
  const { colorThemes, isLoading: colorThemesLoading } = useCharacterColorThemes();

  const activeAgeGroups = ageGroups.filter(ag => ag.is_active).map(ag => ({ value: ag.name, label: ag.name }));
  const activeColorThemes = colorThemes.filter(ct => ct.is_active).map(ct => ({ 
    value: ct.name, 
    label: ct.name,
    color: ct.color_hex 
  }));

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold border-b pb-2">Additional Details</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <CharacterFieldSelect
          control={control}
          name="age_group"
          label="Age Group"
          placeholder="Select age group"
          options={activeAgeGroups}
          isLoading={ageGroupsLoading}
        />

        <CharacterFieldSelect
          control={control}
          name="color_theme"
          label="Color Theme"
          placeholder="Select color theme"
          options={activeColorThemes}
          isLoading={colorThemesLoading}
          showColorDot={true}
        />
      </div>

      <FormField
        control={control}
        name="teaching_focus"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Teaching Focus</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Describe the character's teaching focus and educational specialties..."
                className="min-h-[80px]"
                {...field} 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="special_talents"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Special Talents</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="List the character's special talents and unique abilities..."
                className="min-h-[80px]"
                {...field} 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
